import BaseModelCorrection from "@/models/BaseModelCorrection.js";

export default {
	list: 'CorrectionLog',
	columns: BaseModelCorrection.columns
}